<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-book">
<h1>About the Book</h1>
<p>After a sunset concert at the pavilion, they walked home by the harbor. Finn asked her to sit for a while with him, and then he declared himself. He took her hand and said, “Molly, my beautiful one, I have loved you from the time I moved into your family’s house. I can’t hold back any longer, and I am asking if you would consider being my wife.”</p>
<p>Her eyes widened with surprise, and then she said, "I love you more than anything, and I want to be with you forever.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?50484f3a